import errorMessages from '@components/Checkout/Misc/errorMessages';
import { UserType } from '@nextTypes/user';
import { getAPIUrl } from '@nextUtils/urlUtils';

/**
 * Fetches the current user's data from the API.
 */
export const getUser = async (): Promise<UserType> => {
  const userResponse = await fetch(`${getAPIUrl()}/api/v2/user`);

  if (!userResponse.ok) {
    throw new Error(errorMessages.ERROR_WITH_USER_CALL);
  }

  const { user } = await userResponse.json();

  return user;
};
